import Swiper from 'swiper'
import { Autoplay, EffectFade, Navigation } from 'swiper/modules'
import 'swiper/scss'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'

import { HERO_MBP_REVEAL_PX } from './init-hero-studio-scroll.js'

/**
 * Слайды в «экране» макбука. 2+: fade, autoplay, стрелки. Пока трек в начале (не прокручено вправо) — слайды выключены (см. heroMbp:reveal).
 */
export function initHeroMacbookSwiper() {
  const el = document.querySelector('[data-hero-macbook-swiper]')
  if (!el) {
    return
  }

  const n = el.querySelectorAll('.swiper-slide').length
  if (n < 1) {
    return
  }

  const root = el.closest('[data-hero-studio]')
  const isMulti = n > 1
  const prevEl = el.querySelector('.hero-studio__screen-nav--prev')
  const nextEl = el.querySelector('.hero-studio__screen-nav--next')

  const inst = new Swiper(el, {
    modules: isMulti ? [Autoplay, EffectFade, Navigation] : [],
    effect: isMulti ? 'fade' : 'slide',
    fadeEffect: isMulti ? { crossFade: true } : undefined,
    speed: 600,
    loop: isMulti,
    allowTouchMove: isMulti,
    watchOverflow: true,
    nested: true,
    navigation:
      isMulti && prevEl && nextEl
        ? {
            prevEl,
            nextEl,
          }
        : undefined,
    autoplay: isMulti
      ? {
          delay: 4800,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }
      : false,
  })

  if (!isMulti) {
    return
  }

  const applyRevealed = (revealed) => {
    if (revealed) {
      inst.enable()
      inst.autoplay?.start?.()
    } else {
      inst.autoplay?.stop?.()
      inst.disable()
    }
  }

  const getInitialRevealed = () => {
    const sc = root?.querySelector('.hero-studio__scroll')
    if (!sc) {
      return true
    }
    const max = sc.scrollWidth - sc.clientWidth
    if (max <= 0) {
      return true
    }
    return sc.scrollLeft >= HERO_MBP_REVEAL_PX
  }

  applyRevealed(getInitialRevealed())

  if (root) {
    const onMbp = (e) => {
      if (e?.detail && typeof e.detail.revealed === 'boolean') {
        applyRevealed(e.detail.revealed)
      }
    }
    root.addEventListener('heroMbp:reveal', onMbp)
  }
}
